
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { CreateTechniqueFormValues } from './FormSchema';

interface KeyPointsFieldProps {
  form: UseFormReturn<CreateTechniqueFormValues>;
}

export const KeyPointsField: React.FC<KeyPointsFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="keyPoints"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Key Points*</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Enter key points separated by commas (e.g., Keep base low, Control posture, Apply leverage)"
              className="min-h-[80px]"
              {...field}
            />
          </FormControl>
          <FormDescription>
            Enter important points about this technique, separated by commas
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
